/**
 * KANBAN THUNKS — i cinque thunk CRUD standard, dal factory condiviso.
 * TS-101: nessun thunk di membership — la board è una vista a filtro e carica i propri
 * item dal REST dell'entità (vedi KanbanBoardPage), non da un endpoint della bacheca.
 */

import type { ServerListParams } from '@crm/shared';
import { createCrudThunks } from '../../store/createCrudThunks';
import { kanbanApi } from './kanbanApi';
import type { Kanban } from './kanbanMappers';
import type {
  KanbanCreatePayload,
  KanbanUpdatePayload,
} from './kanbanTypes';

const thunks = createCrudThunks<
  Kanban,
  KanbanCreatePayload,
  KanbanUpdatePayload,
  ServerListParams
>('kanbans', kanbanApi);

export const kanbanThunks = thunks;
export const {
  fetchAll: fetchKanbans,
  fetchOne: fetchKanban,
  create: createKanban,
  update: updateKanban,
  remove: deleteKanban,
} = thunks;
